<template>
  <static-fullscreen-card>
    <template v-slot:header></template>
    <template v-slot:actions>
      <v-btn color="primary" @click="$refs.table.updateData()"><btn-title icon="fas fa-sync-alt">Обновить</btn-title> </v-btn>
      <v-btn color="primary" @click="createNew()" title="Создать элемент"><btn-title icon="far fa-plus-square">Создать</btn-title></v-btn></template
    >
    <portal to="v-main">
      <s-edit-form
        v-model="showEditDialog"
        v-if="showEditDialog"
        :api="url"
        :m="m"
        :id="idEdit"
        :configForm="{ type: 'default' }"
        :init-data="{ parent_id }"
        :opt="{ closeAfterSave: true }"
      />
    </portal>
    <a-table-f-api ref="table" :api="m.api" :defaults="defaults" :model="getModelList(m)" :useQuery="false" @click="onClickRow($event)" />
  </static-fullscreen-card>
</template>

<script>
import { getAccess, genModel, doubleClickDetect, keyDetect } from "@/components/mixings";
export default {
  mixins: [getAccess, genModel, doubleClickDetect, keyDetect],
  components: {},
  data() {
    return {
      idEdit: 0,
      showEditDialog: false,
      dataTable: [],
      title: "",
      parent_id: 0,
      m: {
        title: "",
        isDocument: false,
        api: "/mechti/education/chain",
        types1: [
          { value: 1, text: "Текст" },
          { value: 2, text: "Медиа" },
          { value: 3, text: "Вопрос" },
          { value: 4, text: "Тест" },
        ],
        types: [
          { value: 1, text: "Тема" },
          { value: 2, text: "Ответ" },
        ],
        list: [
          { name: "id", title: "#", type: "id", sortable: true, width: 150 },
          { name: "name", title: "Наименование", type: "string", sortable: true, width: 450 },
          { name: "type", title: "Тип", type: "select", sourceList: "types", sortable: !true },
          { name: "is_parent", title: "", type: "folder", style: "white-space: normal;", sortable: true, width: 50 },
        ],
        form: [
          { name: "is_parent", title: "Раздел", type: "switcher", validator: ["req"], default: 0 },
          { name: "name", title: "Наименование", type: "string", validator: ["req"] },
          { name: "type", title: "Тип", type: "select", sourceList: "types" },
          { name: "status", title: "Статус", validator: ["req"], type: "number", default: 1 },
          { name: "parent_id", default: 0 },
          { name: "accessRoles", title: "для роли..", type: "selectAccess2", accessType: "role", validator1: ["req"], default: [] },
          { name: "accessUsers", title: "для пользователя..", type: "selectAccess2", accessType: "user", validator1: ["req"], default: [] },
        ],
        config: {
          watch: "is_parent",
          default: { fields: "is_parent,name,status,parent_id", fieldsForm: "is_parent,name", fieldsRO: "" },
          0: {
            title: "Урок",
            fields: "is_parent,name,type,status,parent_id,accessRoles,accessUsers",
            fieldsForm: "is_parent,name,type,accessRoles,accessUsers",
            fieldsRO: "",
          },
          1: { title: "Раздел", fields: "is_parent,name,status,parent_id,accessRoles,accessUsers", fieldsForm: "is_parent,name,accessRoles,accessUsers", fieldsRO: "" },
        },
      },
    };
  },
  created() {
    this.$root.title = "Система обучения";
  },
  computed: {
    defaults() {
      let res = {
        sort: [
          { key: "is_parent", order: "DESC" },
          { key: "id", order: "ASC" },
        ],
        filters: { OR: [{ id: this.parent_id }, { parent_id: this.parent_id }] },
        folder_id: this.parent_id,
        paramName: "",
      };
      return res;
    },
    url() {
      return this.m.api;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  methods: {
    onClickRow(d) {
      if (d.row.is_parent) {
        this.parent_id = this.parent_id != d.row.id ? d.row.id : d.row.parent_id;
        return;
      }
      this.showEditDialogFun(d.row.id);
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
  },
};
</script>
